import { render, staticRenderFns } from "./TripDetail.vue?vue&type=template&id=ac5a0870&"
import script from "./TripDetail.vue?vue&type=script&lang=js&"
export * from "./TripDetail.vue?vue&type=script&lang=js&"
import style0 from "./TripDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports